import React from 'react';
import { useTranslation } from 'react-i18next';
import SocialSection from '../../component/contact/SocialSection';
import ContactForm from '../../component/contact/ContactForm';
import { FaFacebookF, FaInstagram, FaPhone, FaWhatsapp, FaEnvelope, FaMapMarkerAlt, FaTiktok, FaSnapchatGhost } from 'react-icons/fa';
import './Contact.scss';

// You can add a contact banner image or use a default one
import contactBanner from '../../images/team/MedicalLaboratoryBanner.png';

const socialLinks = [
  { icon: <FaInstagram />, text: 'instagram', link: 'https://www.instagram.com/laboratory.cmp/' },
  { icon: <FaTiktok />, text: 'tiktock', link: 'https://www.tiktok.com/@cmp_laboratory?_r=1&_t=ZS-93KkysfFcCm' },
  { icon: <FaSnapchatGhost />, text: 'snapshat', link: 'https://www.snapchat.com/add/cmplab?share_id=2QxqGlMRjTY&locale=en-GB' },
  { icon: <FaFacebookF />, text: 'facebook', link: 'https://www.facebook.com/profile.php?id=61587114271681' },
  { icon: <FaWhatsapp />, text: 'whatsapp', link: 'https://api.whatsapp.com/send/?phone=971501344319&text&type=phone_number&app_absent=0' },
  { icon: <FaEnvelope />, text: 'email', email: 'info.cmplab@gmail.com', link: 'mailto:info.cmplab@gmail.com' },
  { icon: <FaPhone />, text: 'phone', phoneNumber: '0501344319' },
  { icon: <FaPhone />, text: 'phone', phoneNumber: '0569972730' },
  { icon: <FaMapMarkerAlt />, text: 'address', location: 'Sharjah, Khorfakkan', link: "https://maps.app.goo.gl/Jetzk67KLinc291M7" },
];

const ContactUs = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  return (
    <div dir={isRTL ? "rtl" : "ltr"} className="bg-white">
      {/* ===== Banner/Header ===== */}
      <header
        className="relative w-full h-[200px] md:h-[200px] flex flex-col justify-center items-center text-center text-white"
        style={{
          backgroundImage: `url(${contactBanner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/* Overlay */}
        <div className="absolute inset-0 bg-black/60"></div>

        {/* Header Text */}
        <div className="relative z-10 px-4">
          <h1 className="text-4xl md:text-5xl font-extrabold mb-4 inline-block">
            {t("contact.header")}
            <span className="block w-32 h-1 bg-secondColor mx-auto mt-3 rounded-full"></span>
          </h1>
          <h2 className="text-lg md:text-xl font-medium max-w-2xl mx-auto">
            {t("contact.subHeader")}
          </h2>
        </div>
      </header>

      {/* ===== Main Content Section ===== */}
      <section className="py-16 md:py-24">
        <div className="container mx-auto px-6">
          {/* Contact Content */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
            {/* Left Column: Contact Form */}
            <div className="relative">
              <div className="lg:sticky lg:top-24">
                <div className="p-6 md:p-8 rounded-3xl shadow-lg border border-gray-100 bg-white">
                  <h3 className="text-2xl font-bold text-primeColor-600 mb-6 relative">
                    {t("contact.form.message")}
                    <span className="block w-10 h-1 bg-secondColor mt-2 rounded-full" />
                  </h3>
                  <ContactForm />
                </div>
              </div>
            </div>

            {/* Right Column: Contact Information */}
            <div>
              {/* Contact Info Cards */}
              <div className="mb-10">
                <h2 className="text-2xl font-bold text-primeColor-600 mb-6 relative">
                  {t("contact.subHeader")}
                  <span className="block w-10 h-1 bg-secondColor mt-2 rounded-full" />
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
                  {socialLinks.map((link, index) => (
                    <SocialSection
                      key={index}
                      icon={link.icon}
                      text={t(`contact.social.${link.text}`)}
                      link={link.link}
                      phoneNumber={link.phoneNumber}
                      email={link.email}
                      location={link.location}
                      isAddress={link.text === 'address'}
                      language={i18n.language}
                    />
                  ))}
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactUs;